export function bearingDistance(lat, lon, radius, bearing) {
    const lat1Rads = toRad(lat);
    const lon1Rads = toRad(lon);
    const R_KM = 6371 * 1000; // radius in KM
    const d = radius / R_KM; //angular distance on earth's surface

    const bearingRads = toRad(bearing);
    const lat2Rads = Math.asin(
        Math.sin(lat1Rads) * Math.cos(d) + Math.cos(lat1Rads) * Math.sin(d) * Math.cos(bearingRads)
    );

    const lon2Rads = lon1Rads + Math.atan2(
        Math.sin(bearingRads) * Math.sin(d) * Math.cos(lat1Rads),
        Math.cos(d) - Math.sin(lat1Rads) * Math.sin(lat2Rads)
    );

    return {
        latitude: toDeg(lat2Rads),
        longitude: toDeg(lon2Rads)
    }
}

function toRad(degrees) {
    return degrees * Math.PI / 180;
}

function toDeg(radians) {
    return radians * 180 / Math.PI;
}

export function getVehiclesWithEpoch(departures, epoch) {

    var stops = {};

    // debugger;
    for (var log of departures) {
        if (log.timestamp < epoch) {
            if (typeof stops[log.stop_id] == 'undefined' || stops[log.stop_id].timestamp < log.timestamp) {
                stops[log.stop_id] = log;
                stops[log.stop_id].departures = stops[log.stop_id].departures.filter(r => r.arrival != 0xFFFFFFFF).map(function(row){
                    // debugger;
                    var seconds_away = row.departure - log.timestamp;
                    // console.log(row.departure, log.timestamp);
                    // console.log(seconds_away)

                    var minutes_away = Math.round(seconds_away/60);

                    if(minutes_away <= 0){
                        row.arrival_text = 'Now'
                    }
                    else{
                        row.arrival_text = minutes_away;
                    }

                    return row;
                })
            }
        }
    }

    return stops;
}

export function getHeatmapObjectsWithEpoch(device_objects, epoch) {

    var times = {};

    for (var uuid in device_objects) {
        for (var snapshot of device_objects[uuid]) {

            if (Number(snapshot.timestamp) > epoch) {
                break;
            }

            times[uuid] = snapshot;
        }
    }

    // //console.log(times)

    return times;
}

export function processCameraDeviceLocations(devices, locations){

    console.log(locations);

    devices = devices.map((device) => {
        device.location = locations.find((row) => row.uuid == device.uuid);
        if(typeof device.location.multiplier == 'undefined'){
            device.location.multiplier = 1;
        }
        return device;
    })
    
    return devices;
}

// export function getObjectsWithEpochs(device_objects, current_epoch, history_epoch) {

//     var times = {
//         historic_mean: 0,
//         current_mean: 0,
//     };

//     //console.log(device_objects)

//     for (var uuid in device_objects) {
//         if (typeof times[uuid] == 'undefined') {
//             times[uuid] = {
//                 historic: {
//                     objects: [],
//                     min: 0,
//                     max: 0,
//                     mean: 0,
//                     latest_count: 0,
//                     total_count: 0,
//                     times_hit: 0,
//                 },
//                 current: {
//                     objects: [],
//                     min: 0,
//                     max: 0,
//                     mean: 0,
//                     latest_count: 0,
//                     total_count: 0,
//                     times_hit: 0,
//                 }
//             };
//         }

//         if (device_objects) {
//             for (var snapshot of device_objects[uuid]) {
//                 if (Number(snapshot.timestamp) > history_epoch.clone().subtract(1, 'hour').unix() && Number(snapshot.timestamp) <= history_epoch.clone().unix()) {
//                     times[uuid].historic.objects.push(...snapshot.objects);
//                     times[uuid].historic.times_hit++;

//                     if (times[uuid].historic.min > snapshot.objects.length) {
//                         times[uuid].historic.min = snapshot.objects.length;
//                     }
//                     if (times[uuid].historic.max < snapshot.objects.length) {
//                         times[uuid].historic.max = snapshot.objects.length;
//                     }

//                     times[uuid].historic.mean = times[uuid].historic.objects.length / times[uuid].historic.times_hit;
//                     times[uuid].historic.total_count = times[uuid].historic.objects.length;
//                     times[uuid].historic.latest_count = snapshot.objects.length;
//                 }
//                 else if (Number(snapshot.timestamp) > current_epoch.clone().subtract(1, 'hour').unix() && Number(snapshot.timestamp) <= current_epoch.clone().unix()) {
//                     times[uuid].current.objects.push(...snapshot.objects);
//                     times[uuid].current.times_hit++;

//                     if (times[uuid].current.min > snapshot.objects.length) {
//                         times[uuid].current.min = snapshot.objects.length;
//                     }
//                     if (times[uuid].current.max < snapshot.objects.length) {
//                         times[uuid].current.max = snapshot.objects.length;
//                     }

//                     times[uuid].current.mean = times[uuid].current.objects.length / times[uuid].current.times_hit;
//                     times[uuid].current.total_count = times[uuid].current.objects.length;
//                     times[uuid].current.latest_count = snapshot.objects.length;
//                 }
//                 else if (Number(snapshot.timestamp) > current_epoch.clone().unix()) {
//                     break;
//                 }
//             }

//             times.historic_mean += times[uuid].historic.latest_count / times[uuid].historic.times_hit;
//             times.current_mean += times[uuid].current.latest_count / times[uuid].current.times_hit;
//         }
//     }

//     times.historic_mean = Math.round(times.historic_mean);
//     times.current_mean = Math.round(times.current_mean);
//     // //console.log(times);

//     return times;
// }

// export function getObjectsLive(device_objects) {

//     var times = {};

//     for (var uuid in device_objects) {

//         times[uuid] = device_objects[uuid].pop();
//     }

//     return times;
// }

// export function convertCrowdStatsData(devices, objects, differences, map_data) {

//     var processed_data = [];

//     // //console.log(devices);
//     // //console.log(objects);
//     // //console.log(map_data);

//     for (var device of devices) {

//         var ret = {
//             name: device.name,
//             uuid: device.uuid,
//             site_id: device.stop.site_id,
//             people_count: 0,
//             percentage: '0%',
//             difference: '0%',
//             historic_count: 0,
//             current_count: 0
//         };

//         if (differences[device.uuid]) {
//             // //console.log(objects[device.uuid])
//             ret.people_count = objects[device.uuid] ? objects[device.uuid].objects.length : 0;

//             //console.log(ret.people_count, map_data.points.length)

//             ret.percentage = ((ret.people_count / map_data.points.length) * 100).toFixed(1);
//             ret.percentage = isNaN(ret.percentage) || ret.percentage == 0 ? `0%` : `${ret.percentage}%`;

//             if (differences[device.uuid].historic.total_count == 0 && differences[device.uuid].current.total_count > 0) {
//                 ret.difference = differences[device.uuid].current.total_count * 100;
//             }
//             else {
//                 ret.difference = (((differences[device.uuid].current.total_count - differences[device.uuid].historic.total_count) / differences[device.uuid].historic.total_count) * 100).toFixed(1)
//             }
//             ret.difference = isNaN(ret.difference) || ret.difference == 0 ? `0%` : `${ret.difference}%`;

//             ret.historic_count = differences[device.uuid].historic.total_count;
//             ret.current_count = differences[device.uuid].current.total_count;
//         }

//         processed_data.push(ret);
//     }

//     return processed_data;
// }